import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import actions from './locales/en/actions.json';
import capture from './locales/en/capture.json';
import common from './locales/en/common.json';
import greeting from './locales/en/greeting.json';
import items from './locales/en/items.json';
import onboarding from './locales/en/onboarding.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      common,
      greeting,
      actions,
      onboarding,
      capture,
      items,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: ['common', 'greeting', 'actions', 'onboarding', 'capture', 'items'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
